import { Icon, Text } from '@kanda-libs/ks-design-library';

export interface CustomerInfoCardCustomerEmailProps {
  email: string | undefined;
  isLoading: boolean;
}

const CustomerInfoCardCustomerEmail: React.FunctionComponent<CustomerInfoCardCustomerEmailProps> =
  function ({ email, isLoading }) {
    return (
      <div className="flex flex-row gap-x-3">
        <Icon
          icon="email"
          isLoading={isLoading}
          stroke="purple-500"
          size={16}
          className="min-w-4 my-auto"
        />
        <Text
          text={
            email ? (
              <a
                href={`mailto:${email}`}
                target="_blank"
                rel="noreferrer"
                className="underline"
              >
                {email}
              </a>
            ) : (
              <p>No email given</p>
            )
          }
          isLoading={isLoading}
          className="text-13-14 text-neutral-700 my-auto"
          skeletonProps={{
            width: 50,
          }}
        />
      </div>
    );
  };

export default CustomerInfoCardCustomerEmail;
